import logo from './logo.svg';
import './App.css';
import SearchWrapper from './components/SearchWrapper';
import bootstrap from 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div>
      <div className="glow-container">
        <div className="ball"></div>
        <div className="ball ball-1"></div>
        <div className="ball ball-2"></div>
      </div>
    <SearchWrapper />
    </div>
  );
}

export default App;
